











































































































import {Component, Prop, Watch, Mixins} from 'vue-property-decorator'
import {$, Helper, MixinQueryRouter} from 'simpli-web-sdk'
import {CentroDeCusto} from '@/model/resource/CentroDeCusto'
import {CentroDeCustoCollection} from '@/model/collection/CentroDeCustoCollection'
import {ListCentroDeCustoSchema} from '@/schema/resource/CentroDeCusto/ListCentroDeCustoSchema'
import {CsvCentroDeCustoSchema} from '@/schema/resource/CentroDeCusto/CsvCentroDeCustoSchema'

@Component
export default class ListCentroDeCustoView extends Mixins(MixinQueryRouter) {
  schema = new ListCentroDeCustoSchema()
  collection = new CentroDeCustoCollection()

  async created() {
    await this.query()
  }

  goToPersistView(item: CentroDeCusto) {
    Helper.pushByName('editCentroDeCusto', item.$id)
  }

  async downloadCsv() {
    const {params} = this.collection
    delete params.ascending
    delete params.orderBy
    delete params.page
    delete params.limit

    const csv = new CentroDeCustoCollection().clearFilters().addFilter(params)

    await csv.listCsvCentroDeCusto()
    new CsvCentroDeCustoSchema().downloadCsv(csv.all())
  }
}
